import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_URL: z.string().min(1, 'VITE_API_URL is required'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_CRISP_WEBSITE_ID: z.string().optional(),
});

/**
 * Validated once at module load: a build with a missing `VITE_API_URL` fails
 * at boot with a clear ZodError instead of producing `undefined` URLs
 * mid-flow. Vite builtins (`DEV`, `MODE`) stay on `import.meta.env`.
 */
export const env = EnvSchema.parse(import.meta.env);
